import React, { useState } from "react";

import {
  Container,
  Separator,
  SideBarCard,
  Header,
  LinksContainer,
  Body,
} from "./styles";

import Symbol from "../../assets/symbol-purple.svg";
import { useAuth } from "../../hooks/AuthContext";
import { LicenseeMenuList } from "./MenuList/LicenseeMenuList";
import { AdminMenuList } from "./MenuList/AdminMenuList";
import { CreatorMenuList } from "./MenuList/CreatorMenuList";
import { SafMenuList } from "./MenuList/SafMenuList";
import { FixiterMenuList } from "./MenuList/FixiterMenuList";
import { roles } from "../../utils/constants";
import { EmployeeMenuList } from "./MenuList/EmployeeMenuList";
import { LanguageSelector } from "../LanguageSelector";

const DesktopSideBar = () => {
  const [extendedMode] = useState(true);
  const { user } = useAuth();

  return (
    <Container extendedMode={extendedMode}>
      <SideBarCard>
        <Header>
          <img
            src={Symbol}
            width="60px"
            height="60px"
            style={{ userSelect: "none" }}
            alt="Fix it"
          />
          <Separator />
        </Header>

        <Body>
          <LinksContainer>
            {user.role === roles.licensee && (
              <LicenseeMenuList extendedMode={extendedMode} />
            )}
            {user.role === roles.creator && (
              <CreatorMenuList extendedMode={extendedMode} />
            )}
            {user.role === roles.admin && (
              <AdminMenuList extendedMode={extendedMode} />
            )}
            {user.role === roles.saf && (
              <SafMenuList extendedMode={extendedMode} />
            )}
            {user.role === roles.fixiter && (
              <FixiterMenuList extendedMode={extendedMode} />
            )}
            {user.role === roles.employee && (
              <EmployeeMenuList extendedMode={extendedMode} />
            )}
          </LinksContainer>

          <LanguageSelector position="top" variant="solid" />
        </Body>
      </SideBarCard>
    </Container>
  );
};

export default DesktopSideBar;
